import type { LearningContentStatus } from '@mathflat/domain/@entities/StudentWorksheet/api2'
import { useEffect } from 'react'

import dailyLearningTimeService from '../services/dailyLearningTime.service'
import learningTimeService from '../services/learningTime.service'

/**
 *
 * @description 총 학습시간 저장하는 hook, 내부에서 예외 처리하므로 try...catch 불필요.
 *   `enabled = false` 면 어떤 시점에도 트래킹하지 않음(학부모, 베이직)
 */
export const useLearningTime = (
  worksheetType?: 'DAILY' | 'CUSTOM',
  status?: LearningContentStatus,
  enabled: boolean = true,
) => {
  const service = worksheetType === 'DAILY' ? dailyLearningTimeService : learningTimeService

  const start = async () => {
    if (!enabled) return
    if (worksheetType === 'DAILY' && status === 'COMPLETE') {
      return
    }

    await service.start()
  }

  const stop = async () => {
    if (!enabled) return
    await service.stop()
  }

  useEffect(() => {
    if (!enabled) return

    const onVisibilityChange = () => {
      if (document.hidden) {
        void stop()
      } else {
        void start()
      }
    }
    void start()
    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      void stop()
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [service, enabled])

  return {
    start,
    stop,
  }
}
